import { getItem } from "./local-storage"

export const getToken = () => {
  return getItem('accessToken')
}
